<template>
  <div>
    <div class="pic_question clearfloat" id="vm">
      <input @change="fileChange($event)" type="file" ref="upload_file" id="ddddddd" multiple hidden
        accept=".png, .jpg, .jpeg, .jpeg, image/png, image/jpg, image/jpeg, image/gif" />
      <ul class="img-list clearfloat">
        <li v-for="(url, index) in imgcontainer" :key="index">
          <Icon class="del" type="md-close-circle" @click.stop="delImg('one', index)" v-if="!readonly" />
          <img :src="axios.platConfig.fileUri + url" @click="img(index)" />
        </li>
        <viewer v-show="false" v-if="imgmmm">
          <img v-for="(url, index) in imgcontainer" :key="index" :src="axios.platConfig.fileUri + url" width="30"
            height="30" :id="'lyImg' + index" />
        </viewer>
      </ul>
      <div class="add-image" @click="open" v-if="!(one != undefined && imgcontainer.length == 1) && !readonly">
        <Icon type="ios-add" />
      </div>

      <!-- <button @click="replace('http:test/1234')">获取数据</button> -->
    </div>
  </div>
</template>
<script>
export default {
  props: ["imgModel", "one", "keep", "api", "readonly"],
  data() {
    return {
      //imgModel: [],
      size: 0,
      limitSize: 500,//压缩图片大小,单位kb
      quality: 1,//压缩质量
      limit: 6, //限制图片上传的数量
      tempImgs: [],
      isCamera: true,
      mode: true,
      imgModel123: "",
      imgcontainer: [],
      imgmmm: true,
      width: 1000
    };
  },
  methods: {
    img(index) {
      var a = document.getElementById("lyImg" + index);
      a.click();
    },
    open() {
      this.$refs.upload_file.click();
    },
    async fileChange(el) {
      var files = el.target.files;
      console.log(files);
      for (let i = 0; i < files.length; i++) {
        var m = el.target.files[i];
        if (!this.keep) {
          m = await this.compressImage(m, this.quality, this.limitSize);
        }

        //console.log(m.size / 1024 / 1024, "压缩的图片file");
        var api = this.api ? this.api : "";
        let params = new window.FormData();
        params.append("file", m);
        params.append("api", api);

        //params.append("isOrgFileName", false);
        this.utils.loading(this, "加载中");
        this.axios({
          method: "post",
          url: this.axios.oss + "/file/upload",
          data: params,
        }).then((res) => {
          this.$Spin.hide(); //关闭加载
          if (res) {
            this.imgcontainer.push(res.data.data.path);
            if (this.one) {
              this.$emit("bbbbb", this.imgcontainer[0]);
              console.log(this.imgcontainer[0]);
            } else {
              this.$emit("bbbbb", this.imgcontainer);
            }
          }
        });
      }
      return;
    },
    delImg(type, index) {
      this.imgcontainer.splice(index, 1);
    },
    reset() {
      if (this.imgcontainer.length > 0) {
        this.imgcontainer.splice(0, 10);
      }
    },
    imgModelToImgcontainer(v) {
      if (this.one) {
        this.utils.isEmpty(v)
          ? (this.imgcontainer = [])
          : (this.imgcontainer = [v]);
      } else {
        this.utils.isEmpty(v)
          ? (this.imgcontainer = [])
          : (this.imgcontainer = v);
      }
    },
    //以下是图片压缩
    compressImage(file, quality, size) {
      return new Promise((resolve, reject) => {
        try {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          var that = this;
          reader.onload = (e) => {
            const image = new Image();
            image.src = e.target.result;

            image.onload = () => {
              const canvas = document.createElement("canvas");
              const ctx = canvas.getContext("2d");
              let width = image.width;
              let height = image.height;
              const scale = width / height;
              width = this.width;
              height = width / scale;
              canvas.width = width;
              canvas.height = height;
              ctx.drawImage(image, 0, 0, width, height);
              let dataURL = canvas.toDataURL(file.type, quality);
              while (dataURL.length / 1024  > size) {
                quality -= 0.1;
                dataURL = canvas.toDataURL(file.type, quality);
              }
              const newFile = that.convertBase64UrlToBlob(dataURL);
              resolve(newFile);
            };
          };
        } catch (e) {
          console.log("图片压缩异常: ", e);
          reject(null);
        }
      });
    },
    // base64转成blod格式文件
    convertBase64UrlToBlob(urlData) {
      var arr = urlData.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      var data = new Blob([u8arr], { type: mime });
      const file = new File([data], "icon.png", { type: "image/png" });
      return file;
    },
    // base64转成blod格式文件
    convertBase64UrlToBlob2(urlData) {
      var arr = urlData.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      var data = new Blob([u8arr], { type: mime });

      //console.log(file.size / 1024 / 1024, "压缩的图片file");

      var promise = new Promise((resolve) => {
        const file = new File([data], "icon.png", { type: "image/png" });
        resolve(file);
      });
      return promise;
    },
  },
  model: {
    prop: "imgModel",
    event: "bbbbb",
  },
  watch: {
    imgModel(v) {
      this.imgModelToImgcontainer(v);
    },
    imgcontainer(v) {
      this.imgmmm = false;
      setTimeout(() => {
        this.imgmmm = true;
      }, 200);
    },
  },
  created() {
    var v = this.imgModel;
    this.imgModelToImgcontainer(v);
  },
};
</script>
<style lang="">
.pic_question {
  padding: 0 0.48rem;
}

.add-image {
  float: left;
  width: 60px;
  height: 60px;
  font-size: 60px;
  color: #868686;
  position: relative;
  border: 1px solid #7a7a7a;
  text-align: center;
  line-height: 2.8rem;
  font-weight: lighter;
}

.img-list {
  flex-wrap: wrap;
  float: left;
}

.img-list > li {
  width: 60px;
  height: 60px;
  position: relative;
  margin-right: 10px;
  margin-bottom: 10px;
  display: inline-block;
}
.img-list > li .del {
  position: absolute;
  top: -8px;
  right: -4px;
  color: #2c2c2c;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  opacity: 0.5;
  font-size: 24px;
}
.img-list > li > img {
  width: 100%;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// ../common/src/components/lyPhoto.vue